<script setup lang="ts">
import model from '@/ts/model.ts';
import UnknownFlag from '@/assets/flags/unknown.png?url';

const props = defineProps<{flag: string, size?: number, sizeMobile?: number}>();

const flags = import.meta.glob('@/assets/flags/*.png', {eager: true, query: '?url', import: 'default'});

function getSize(){
    return (model.isMobile ? (props.sizeMobile || props.size) : props.size) + 'px';
}

function getFlag(){
    let iso = props.flag;
    if(iso.length == 2) iso = iso.toUpperCase();

    for(const key in flags){
        const val = flags[key];

        if(key.includes(iso + '.')) return val;
    }

    return UnknownFlag;
}

</script>

<template>
    <div 
        :style="{
            backgroundImage: `url(${getFlag()})`, 
            width: getSize(), 
            height: getSize(),
        }" 
        class="flag"
    ></div>
</template>

<style lang="scss" scoped>
    .flag {
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
</style>